import { useContext, useState, useEffect } from 'react'
import { ConfiguratorContext } from '../../Contexts/Configuration'
import { NavigationNode } from '../../Services/Navigation'
import ViewType from '../../Types/ViewType'
import DatePicker from 'react-date-picker';
import './FirstDataPageView.css'
import Radio from '../../../../Components/Radio/Radio'
import { Picker } from "@react-native-picker/picker";
import { validateAlphaString, validateFiscalCode, validateProvince, validateSdi, validateVatNumber } from '../../Services/Validation'
import API from "../../Services/API"

const FirstDataPageView = () => {
	let context = useContext(ConfiguratorContext)

	let [provinces, setProvinces] = useState<string[]>(context.provincesList ? context.provincesList : [])
	let [municipalities, setMunicipalities] = useState<string[]>(context.firstMunicipalitiesList ? context.firstMunicipalitiesList : [])
	let [businessName, setBusinessName] = useState(context.businessName)
	let [businessNameError, setBusinessNameError] = useState("")
	let [name, setName] = useState(context.name)
	let [nameError, setNameError] = useState("")
	let [surname, setSurname] = useState(context.surname)
	let [surnameError, setSurnameError] = useState("")
	let [gender, setGender] = useState(context.gender)
	let [foreignBirthPlace, setForeignBirthPlace] = useState(context.foreignBirthPlace)
	let [birthDate, setBirthDate] = useState(context.birthDate)
	let [birthDateError, setBirthDateError] = useState("")
	let [birthProvince, setBirthProvince] = useState(context.birthProvince)
	let [birthProvinceError, setBirthProvinceError] = useState("")
	let [birthMunicipality, setBirthMunicipality] = useState(context.birthMunicipality)
	let [birthMunicipalityError, setBirthMunicipalityError] = useState("")
	let [fiscalCode, setFiscalCode] = useState(context.fiscalCode)
	let [fiscalCodeError, setFiscalCodeError] = useState("")
	let [sdi, setSdi] = useState(context.sdi)
	let [sdiError, setSdiError] = useState("")
	let [vatNumber, setVatNumber] = useState(context.vatNumber)
	let [vatNumberError, setVatNumberError] = useState("")

	context.validateFirstDataPage = () => {

		let validBusinessName = validateAlphaString(businessName ?? "")
		setBusinessNameError(validBusinessName ? "" : "Inserisci la Ragione Sociale")
		context.businessName = businessName?.trim()

		let validName = validateAlphaString(name ?? "")
		setNameError(validName ? "" : "Inserisci il nome")
		context.name = name?.trim()

		let validSurname = validateAlphaString(surname ?? "")
		setSurnameError(validSurname ? "" : "Inserisci il cognome")
		context.surname = surname?.trim()

		let validBirthProvince = false
		if (foreignBirthPlace) validBirthProvince = validateAlphaString(birthProvince ?? "")
		else validBirthProvince = validateProvince(birthProvince ?? "")

		if (foreignBirthPlace) setBirthProvinceError(validBirthProvince ? "" : "Inserisci una provincia")
		else setBirthProvinceError(validBirthProvince ? "" : "Seleziona una provincia")
		if (validBirthProvince) context.birthProvince = birthProvince?.trim()

		let validBirthMunicipality = validateAlphaString(birthMunicipality ?? "")
		if (foreignBirthPlace) setBirthMunicipalityError(validBirthMunicipality ? "" : "Inserisci il comune di nascita")
		else setBirthMunicipalityError(validBirthMunicipality ? "" : "Seleziona il comune di nascita")
		if (validBirthMunicipality) context.birthMunicipality = birthMunicipality?.trim()

		let validBirthDate = birthDate !== undefined
		setBirthDateError(validBirthDate ? "" : "Seleziona la data di nascita")
		if (validBirthDate) context.birthDate = birthDate

		let validFiscalCode = validateFiscalCode(fiscalCode ?? "")
		setFiscalCodeError(validFiscalCode ? "" : "Il Codice Fiscale inserito non è valido")
		if (validFiscalCode) context.fiscalCode = fiscalCode?.trim()

		let validVatNumber = false
		if (vatNumber === fiscalCode && validFiscalCode) validVatNumber = true
		else {
			validVatNumber = validateVatNumber(vatNumber ?? "")
			setVatNumberError(validVatNumber ? "" : "La partita Iva inserita non è valida")
		}
		if (validVatNumber) context.vatNumber = vatNumber?.trim()

		let validSdi = validateSdi(sdi ?? "")
		setSdiError(validSdi ? "" : "L' Sdi inserito non è valido")
		if (validSdi) context.sdi = sdi?.trim()

		context.gender = gender
		context.foreignBirthPlace = foreignBirthPlace

		context.firstMunicipalitiesList = municipalities

		if (context.isHomeUse) {
			return validName && validSurname && validBirthMunicipality
				&& validBirthProvince && birthDate !== undefined && validFiscalCode
		} else {
			return validBusinessName && validName && validSurname
				&& validVatNumber && validSdi && validFiscalCode
		}
	}

	useEffect(() => {
		(async () => {
			let o = await API.getProvincesAsync();
			if (o.success) {
				setProvinces(o.data);
			}
		})()
		return () => { }
	}, [])

	const getMunicipalitiesByProvince = async (province: string) => {
		let o = await API.getMunicipalitiesAsync(province);
		if (o.success) {
			setMunicipalities(o.data);
		}
	}

	function GenderInput() {
		if (context.isHomeUse) {
			return (
				<div>
					<div className="first-page-label-question">Genere</div>
					<div className="gender-question">
						<Radio title='Uomo' onChange={() => setGender(true)} checked={gender} />
						<Radio title='Donna' onChange={() => setGender(false)} checked={!gender} />
					</div>
				</div>
			)
		}
	}

	function ForeignBirthPlaceInput() {
		if (context.isHomeUse) {
			return (
				<div>
					<div className="first-page-label-question">Luogo di nascita estero</div>
					<div className="gender-question">
						<Radio title='Si' onChange={() => setForeignBirthPlace(true)} checked={foreignBirthPlace} />
						<Radio title='No' onChange={() => setForeignBirthPlace(false)} checked={!foreignBirthPlace} />
					</div>
				</div>
			)
		}
	}

	function BusinessNameInput() {
		if (!context.isHomeUse) {
			return (
				<div className='input-error'>
					<div className="first-page-label-question">Ragione Sociale</div>
					<input value={businessName} onChange={s => setBusinessName(s.target.value)} className="first-data-page-input" />
					<div className='label-error'>{businessNameError}</div>
				</div>
			)
		}
	}

	function TaxCodeInput() {
		if (context.isHomeUse) {
			return (
				<div className='input-error'>
					<div className="first-page-label-question">Codice Fiscale</div>
					<input value={fiscalCode} onChange={s => setFiscalCode(s.target.value.toUpperCase())} className="first-data-page-input" />
					<div className='label-error'>{fiscalCodeError}</div>
				</div>
			)
		}
		else {
			return (
				<div className="first-data-page-tax-code-container">
					<div className='input-error'>
						<div className="first-page-label-question">Codice Fiscale</div>
						<input value={fiscalCode} onChange={s => setFiscalCode(s.target.value.toUpperCase())} className="first-data-page-input" />
						<div className='label-error'>{fiscalCodeError}</div>
					</div>

					<div className='input-error'>
						<div className="first-page-label-question">Partita IVA</div>
						<input value={vatNumber} onChange={s => setVatNumber(s.target.value.toUpperCase())} className="first-data-page-input" />
						<div className='label-error'>{vatNumberError}</div>
					</div>
				</div>
			)
		}
	}

	function SdiInput() {
		if (!context.isHomeUse) {
			return (
				<div className='input-error'>
					<div className="first-page-label-question">SDI</div>
					<input value={sdi} onChange={s => setSdi(s.target.value.toUpperCase())} className="first-data-page-input" />
					<div className='label-error'>{sdiError}</div>
				</div>
			)
		}
	}

	function BirthDataInputs() {
		if (context.isHomeUse && !foreignBirthPlace) {
			return (
				<div className='first-page-input-row'>
					<div>
						<div className="first-page-input-row-label-question">Data di nascita</div>
						<DatePicker
							className="date-picker"
							calendarClassName="date-picker-calendar"
							tileClassName="date-picker-tile"
							onChange={(value: Date, _: any) => setBirthDate(value)}
							value={birthDate}

						/>
						<div className='label-error'>{birthDateError}</div>
					</div>
					<div className='input-error'>
						<div className="first-page-input-row-label-question">Provincia di nascita</div>
						<Picker
							style={{ height: "50px", width: "100%", backgroundColor: "#404998", borderColor: "white", borderStyle: "solid", borderWidth: 1, color: "white", fontSize: 20 }}
							selectedValue={birthProvince}
							onValueChange={async (itemValue) => {
								setBirthProvince(itemValue);
								await getMunicipalitiesByProvince(itemValue);
							}
							}>
							<Picker.Item key='' label='--' value='' />
							{
								provinces.map((province) => {
									return <Picker.Item key={province} label={province} value={province} />;
								})
							}
						</Picker>
						<div className='label-error'>{birthProvinceError}</div>
					</div>
					<div className='input-error'>
						<div className="first-page-input-row-label-question">Comune di nascita</div>
						<Picker
							style={{ height: "50px", width: "100%", backgroundColor: "#404998", borderColor: "white", borderStyle: "solid", borderWidth: 1, color: "white", fontSize: 20 }}
							selectedValue={birthMunicipality}
							onValueChange={(itemValue) => {
								setBirthMunicipality(itemValue);
							}
							}>
							<Picker.Item key='' label='--' value='' />
							{
								municipalities.map((municipality) => {
									return <Picker.Item key={municipality} label={municipality} value={municipality} />;
								})
							}
						</Picker>
						<div className='label-error'>{birthMunicipalityError}</div>
					</div>
				</div>
			)
		}

		if (context.isHomeUse && foreignBirthPlace) {
			return (
				<div className='first-page-input-row'>
					<div>
						<div className="first-page-input-row-label-question">Data di nascita</div>
						<DatePicker
							className="date-picker"
							calendarClassName="date-picker-calendar"
							tileClassName="date-picker-tile"
							onChange={(value: Date, _: any) => setBirthDate(value)}
							value={birthDate}

						/>
						<div className='label-error'>{birthDateError}</div>
					</div>
					<div className='input-error'>
						<div className="first-page-input-row-label-question">Provincia di nascita</div>
						<input value={birthProvince} onChange={n => setBirthProvince(n.target.value)} className="first-data-page-input" />
						<div className='label-error'>{birthProvinceError}</div>
					</div>
					<div className='input-error'>
						<div className="first-page-input-row-label-question">Comune di nascita</div>
						<input value={birthMunicipality} onChange={n => setBirthMunicipality(n.target.value)} className="first-data-page-input" />
						<div className='label-error'>{birthMunicipalityError}</div>
					</div>
				</div>
			)
		}
	}



	return (
		<div className="first-data-page-container">

			<div className='label-error' style={{ fontSize: '25px' }}>{
				businessNameError || nameError || surnameError
					|| birthDateError || birthProvinceError || birthMunicipalityError
					|| fiscalCodeError || vatNumberError || sdiError ?
					"E' necessario compilare tutti i campi obbligatori" : ""}
			</div>

			{BusinessNameInput()}

			<div className='input-error'>
				<div className="first-page-label-question">Nome</div>
				<input value={name} onChange={n => setName(n.target.value)} className="first-data-page-input" />
				<div className='label-error'>{nameError}</div>
			</div>
			<div className='input-error'>
				<div className="first-page-label-question">Cognome</div>
				<input value={surname} onChange={s => setSurname(s.target.value)} className="first-data-page-input" />
				<div className='label-error'>{surnameError}</div>
			</div>

			{GenderInput()}

			{ForeignBirthPlaceInput()}

			{BirthDataInputs()}

			{TaxCodeInput()}

			{SdiInput()}

			<div style={{ minHeight: "20px" }} />
		</div>
	)
}

const FirstDataPageNode: NavigationNode = {
	content: () => <FirstDataPageView />,
	previous: () => ViewType.homeUse,
	next: () => ViewType.enterEmail,
	percentage: 18
}

export default FirstDataPageNode
